import { useCallback, useEffect, useState } from "react";

const COMPACT_BREAKPOINT = 480;

/**
 * Measures the chart plot so Y-axis labels can switch to a compact
 * format on narrow cards without clipping on any viewport.
 */
export const useChartAxisLayout = () => {
  const [node, setNode] = useState(null);
  const [width, setWidth] = useState(0);
  const containerRef = useCallback((element) => {
    setNode(element);
  }, []);

  useEffect(() => {
    if (!node) return undefined;

    const update = (nextWidth) => {
      const rounded = Math.round(nextWidth);
      setWidth((current) => (current === rounded ? current : rounded));
    };

    update(node.clientWidth);

    if (typeof ResizeObserver === "undefined") {
      const onResize = () => update(node.clientWidth);
      window.addEventListener("resize", onResize);
      return () => window.removeEventListener("resize", onResize);
    }

    const observer = new ResizeObserver((entries) => {
      update(entries[0]?.contentRect?.width || node.clientWidth);
    });
    observer.observe(node);
    return () => observer.disconnect();
  }, [node]);

  return {
    containerRef,
    compact: width > 0 && width < COMPACT_BREAKPOINT,
    containerWidth: width,
  };
};
